import React from 'react';
import { Link, Icon } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import site from '../../config/site';

export default function WhatsAppButton({ message }) {
  return (
    <Link
      href={site.whatsapp.href(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribir a SIESA por WhatsApp"
      position="fixed"
      bottom={{ base: 4, md: 6 }}
      right={{ base: 4, md: 6 }}
      zIndex="docked"
      w="56px"
      h="56px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="whatsapp.500"
      color="white"
      borderRadius="full"
      boxShadow="md"
      transitionDuration="200ms"
      _hover={{ bg: 'whatsapp.600', transform: 'scale(1.05)' }}
      _focusVisible={{ boxShadow: 'outline' }}
    >
      <Icon as={FaWhatsapp} boxSize={7} aria-hidden="true" />
    </Link>
  );
}
